import gql from 'graphql-tag';
import { isUndefined } from 'lodash';
import { getGraphQLClientForPivotWithToken } from 'utils/apiRequests';

const exploreLibraryQuery = (request, columns, dateRange) => {
	const { filterModel } = request;
	const fields = columns.map(col => col.field);
	let oldFilterOptions = request.filterModel;
	oldFilterOptions.pO_CREATION_DATE = {
		filterType: 'date',
		operator: 'AND',
		condition1: {
			dateFrom: dateRange.dateFrom,
			type: 'greaterThanOrEqual',
			filterType: 'date',
		},
		condition2: {
			dateFrom: dateRange.dateTo,
			type: 'lessThanOrEqual',
			filterType: 'date',
		},
	};
	const { sPEND, ...filterParam } = filterModel;
	const havingParam = isUndefined(filterModel.sPEND)
		? []
		: [
				{
					id: '5',
					aggFunc: 'Sum',
					displayName: 'sPEND',
					field: 'sPEND',
					type: filterModel.sPEND.type,
					value: filterModel.sPEND.filter.toString(),
					filterType: filterModel.sPEND.type,
				},
		  ];

	return {
		query: gql`
			query (
				$start: Int!
				$end: Int!
				$sortModel: [SortModelType!]
				$filterModel: [FilterModelType!]
		  		$havingModel:[HavingModelType!]
			) {
				getSupplierDiversityAnalyze(
					startRow: $start
					endRow: $end
					sorting: $sortModel
					filterModel: $filterModel,
		  			havingModel:$havingModel
				) {
					${[...fields]}
				}
			}
		`,
		variables: {
			start: request.startRow,
			end: request.endRow,
			sortModel: request.sortModel,
			filterModel: [filterParam],
			havingModel: havingParam,
		},
	};
};

//this function makes columns from the data
const ServerSideDataSource = (...args) => {
	const [gridOptions, , , dateRange] = args;
	return {
		// called by the grid when more rows are required
		getRows: async params => {
			const object = {};
			object.gridOptions = gridOptions;
			object.client = await getGraphQLClientForPivotWithToken();
			const columns = object.gridOptions.columnDefs;

			object.client
				.query(exploreLibraryQuery(params.request, columns, dateRange))
				.then(response => {
					let rows = response.data.getSupplierDiversityAnalyze;
					let lastRow = -1;
					if (rows.length <= gridOptions.cacheBlockSize) {
						lastRow = params.request.startRow + rows.length;
					}
					params.successCallback(rows, lastRow);
				})
				.catch(err => {
					console.error(err);
					params.failCallback();
				});
		},
	};
};

export default ServerSideDataSource;
